import { Entity, MicroMClient } from "@mcurros2/microm";
import { IconMailQuestion } from "@tabler/icons-react";
import { SolicitudesRuteoImportacionProcesoDef } from "./SolicitudesRuteoImportacionProcesoDef";

export const SolicitudesRuteoImportacionProcesoIcon = IconMailQuestion;
export const SolicitudesRuteoImportacionProcesoHelpText = '* Importación de Ruteos';

export class SolicitudesRuteoImportacionProceso extends Entity<SolicitudesRuteoImportacionProcesoDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new SolicitudesRuteoImportacionProcesoDef(), parentKeys);
        this.Form = import('./SolicitudesRuteoImportacionProcesoForm').then((module) => module.SolicitudesRuteoImportacionProcesoForm);
        this.Title = "Importación de Ruteos";
        this.HelpText = SolicitudesRuteoImportacionProcesoHelpText;
        this.Icon = SolicitudesRuteoImportacionProcesoIcon;
    }
}